import { Modal, Box } from '@mui/material';
import { ReactComponent as Close } from '../assets/icon/Close.svg';
import React, { useEffect, useState } from 'react';
import {
  CardComponent,
  FilterComponent,
  PromptTypeButtonComponent,
  SearchComponent
} from './PromptCommonFunctions';
import { usePromptLibraryContext } from '../context/PromptLibraryContext';

type itemType = {
  author: string;
  currentVersion: string;
  description: string;
  title: string;
  totalVersions: number;
  tags: string[];
  is_new: boolean;
  promptID?: string;
  prompt_id?: string;
  is_prompt_type_private: boolean;
  versionDetail?: string;
  latest_version_id?: string;
  versions?: {}[];
};

export default function ModalView({
  open = false,
  handleClose,
  header = '',
  description = '',
  children
}: {
  open?: boolean;
  handleClose?: () => void;
  header?: string;
  description?: string;
  children?: React.ReactNode;
}) {
  const [allPromptCardsData, setAllPromptCardData] = useState<itemType[]>([]);
  const [myPromptCardsData, setmyPromptCardData] = useState<itemType[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [isAllPrompt, setAllPromptStatus] = useState(false);

  const { allPromptData, myPromptData, error, isLoading, getPromptlibraryData } =
    usePromptLibraryContext();
  const selectedType = isAllPrompt ? allPromptData : myPromptData;

  useEffect(() => {
    getPromptlibraryData();
  }, [open]);

  useEffect(() => {
    var temp: itemType[] = [];
    selectedType?.items?.map((item: itemType) => {
      temp.push({
        author: item?.author || 'Steve',
        currentVersion: item?.currentVersion || '99',
        description: item?.description || 'Desc',
        title: item?.title || 'Title',
        totalVersions: item?.totalVersions || 98,
        tags: item?.tags || [],
        is_new: item?.is_new || false,
        promptID: item?.prompt_id || '',
        is_prompt_type_private: item?.is_prompt_type_private || false,
        versionDetail: item?.latest_version_id || '',
        versions: item?.versions || []
      });

      isAllPrompt ? setAllPromptCardData(temp) : setmyPromptCardData(temp);
    });
  }, [isAllPrompt, selectedType, open]);

  const handleFilter = () => {
    return FilterComponent({
      isAllPrompt,
      allPromptCardsData,
      myPromptCardsData,
      searchValue
    });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="alignDataCenter">
      <Box
        style={{
          backgroundColor: 'rgba(255, 255, 255, 1)',
          border: 'none',
          width: '80%',
          height: '80%',
          margin: 'auto',
          borderRadius: '8px',
          padding: 20
        }}>
        <Box
          className="d-flex justify-content-between align-items-start"
          style={{ borderBottom: '1px solid var(--border-color-grey)', width: '100%' }}>
          <Box>
            <div className="h6 w600 un_standard_color" style={{ margin: '10px 0' }}>
              {header}
            </div>
            <p className="h5_400" style={{ fontWeight: 400, color: 'var(--grey_tone)' }}>
              {description}
            </p>
          </Box>{' '}
          <Close style={{ cursor: 'pointer' }} onClick={handleClose} />
        </Box>
        <Box className="d-flex gap-2 w-100 align-items-center py-3">
          <PromptTypeButtonComponent
            isAllPrompt={isAllPrompt}
            handleClick={() => setAllPromptStatus(!isAllPrompt)}
          />

          <SearchComponent
            searchValue={searchValue}
            handleSelection={(name, value) => setSearchValue(value)}
            divCss="w-100"
          />
        </Box>

        <CardComponent
          handleFilter={() => handleFilter()}
          isPromptLibrary={false}
          isAllPrompt={isAllPrompt}
        />
      </Box>
    </Modal>
  );
}
